module.exports = __webpack_public_path__ + "337fb00881802b92d1783798fe0ab1ff.png";